import { Alert, Grid, Tabs } from '@amzn/awsui-components-react';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { get } from 'lodash';
import { BRC_ITEMS_PAGE } from '../../../common/components/with_page/components/bread_crumb/constants';
import Page from '../../../common/components/with_page/Page';
import { RESOURCE } from '../../auth/constants/rbac_constants';
import RiseSurveyTable from './components/RiseSurveyTable';
import { getStudyPeriod } from '../../../common/constants/study_period';
import { setStudyType } from '../../../redux/actions/studyTypeActions';
import { SURVEY_TYPE } from '../../../common/components/pdf_generator/templates/SurveyPDFTemplate/utils/DataUtils';

const RiseSurveyPage = ({ studyPeriod, entityId, studyType }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setStudyType('US_DUAL_ALLOCATION'));
  }, [dispatch]);

  const content =
    studyType === 'US_DUAL_ALLOCATION' ? (
      <Grid gridDefinition={[{ colspan: 12 }]}>
        <div>
          <Tabs
            tabs={[
              {
                label: 'SPO Surveys',
                id: 'spo',
                content: <RiseSurveyTable surveyType={SURVEY_TYPE.LABOR_BC_SUBSTANTIATION} />,
              },
              {
                label: 'SP Surveys',
                id: 'sp',
                content: <RiseSurveyTable surveyType={SURVEY_TYPE.LABOR_PROJECT_SUBSTANTIATION} />,
              },
            ]}
          />
        </div>
      </Grid>
    ) : (
      <div>
        <Alert type="error" header="Page does not exists!">
          Please use side navigation to go back to valid pages.
        </Alert>
      </div>
    );

  return (
    <Page
      PageId={RESOURCE.PAGE_RISE_SURVEY}
      isPageAccessControlled
      PageContent={content}
      breadCrumbItems={BRC_ITEMS_PAGE.RISE_SURVEY(studyPeriod, entityId, studyType)}
    />
  );
};

RiseSurveyPage.propTypes = {
  studyPeriod: PropTypes.string.isRequired,
  entityId: PropTypes.string,
  studyType: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  studyPeriod: getStudyPeriod(state),
  entityId: get(state, 'entityId.entityId', undefined),
  studyType: get(state, 'studyType.studyType'),
});

export default connect(mapStateToProps)(RiseSurveyPage);
